// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Typography,
    DialogActions
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import MsiDatagridCheckbox from '../../../components/custom/MsiDatagridAutoCheckbox';
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    // ** State
    const [tabs, setTabs] = useState<string>("1")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [listData, setListData] = useState<any[]>([])
    const [selectedList, setSelectedList] = useState<any[]>([])
    const [selectedWoList, setSelectedWoList] = useState<any[]>([])
    const [isOto, setIsOto] = useState<any>(null)

    const [openImageDialog, setOpenImageDialog] = useState(false)
    const [imagePreview, setImagePreview] = useState<string | null>(null)
    const [openProductDialog, setOpenProductDialog] = useState<boolean>(false)

    const handleOpenImage = (url: string) => {
        setImagePreview(url)
        setOpenImageDialog(true)
    }

    const handleCloseImage = () => {
        setOpenImageDialog(false)
        setImagePreview(null)
    }

    useEffect(() => {
        getData(tabs)

        const getUserOto = (sysdoctag_id: any) => {
            const url = apiUrl.apiUrl + '/system/user/cek-oto'
            axios
                .get(url, {
                    params: { sysdoctag_id: sysdoctag_id },
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        const data = response.data.data
                        setIsOto(data)
                    } else {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: response.data.message,
                            icon: 'error'
                        })
                    }
                })
        }
        getUserOto(21)
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/production/permintaan-preview/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/production/permintaan-preview/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Hapus Permintaan Preview 17",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/production/permintaan-preview/detail/' + id)}
                />
            ),
        },
    ];

    const editQtyPermintaan = async (row: any) => {
        setOpenProductDialog(false)

        const { value } = await Swal.fire({
            title: 'Edit Qty Permintaan',
            input: 'number',
            inputLabel: row.data?.nama_barang,
            inputValue: row.data?.qty_permintaan || 0,
            inputAttributes: {
                min: '0',
                step: '10' // 🔥 hint ke user bahwa kelipatan 10
            },
            showCancelButton: true,
            confirmButtonText: 'Simpan',
            cancelButtonText: 'Batal',
            inputValidator: (value) => {
                if (value === '' || value === null) {
                    return 'Qty tidak boleh kosong'
                }

                const qty = Number(value)

                if (qty < 0) {
                    return 'Qty tidak boleh minus'
                }

                if (qty < 20) {
                    return 'Qty tidak boleh dibawah 20 '
                }

                if (qty % 10 !== 0) {
                    return 'Qty harus kelipatan 10 (contoh: 20, 30)'
                }

                return null
            }
        })

        if (value !== undefined) {
            const qty = Number(value)
            const id = row.data.id // 🔑 INI KUNCI NYAWA

            // ✅ update listData (grid utama)
            setListData(prev =>
                prev.map(item =>
                    item.id === id
                        ? {
                            ...item,
                            data: {
                                ...item.data,
                                qty_permintaan: qty
                            }
                        }
                        : item
                )
            )

            // ✅ update selectedList (dialog)
            setSelectedList(prev =>
                prev.map(item =>
                    item.id === id
                        ? {
                            ...item,
                            qty_permintaan: qty
                        }
                        : item
                )
            )

            showToast('Qty berhasil diperbarui', 'success')
        }

        setOpenProductDialog(true)
    }


    const convertComponent = [
        {
            key: 'link',
            minWidth: 500,
            renderCell: ({ row }: any) => {
                const url = row.data?.link

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>
                }

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "80px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                        }}
                        onClick={(e) => {
                            e.stopPropagation()
                            handleOpenImage(url)
                        }}
                    />
                )
            }
        },
        {
            key: 'nama_barang',
            minWidth: 300,
            maxWidth: 300,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ maxWidth: 300, whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        {row.data?.nama_barang}
                    </Box>
                );
            }
        },
        {
            key: 'qty_permintaan',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                const qty = row.data?.qty_permintaan ?? row.qty_permintaan ?? 0

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2">
                            {qty}
                        </Typography>

                        <Tooltip title="Edit Qty">
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    editQtyPermintaan(row)
                                }}
                            >
                                <Icon icon="mdi:pencil" fontSize={18} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )
            }
        }
    ];
    const convertComponentAktif = [
        {
            key: 'link',
            minWidth: 500,
            renderCell: ({ row }: any) => {
                const url = row.data?.link

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>
                }

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "80px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                        }}
                        onClick={(e) => {
                            e.stopPropagation()
                            handleOpenImage(url)
                        }}
                    />
                )
            }
        },
        {
            key: 'nama_barang',
            minWidth: 300,
            maxWidth: 300,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ maxWidth: 300, whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        {row.data?.nama_barang}
                    </Box>
                );
            }
        },
    ];

    const handleSelection = (data: any) => {
        setSelectedList(data.selectedRowsData)
    };

    const handleSelectionWo = (data: any) => {
        setSelectedWoList(data.selectedRowsData)
    };

    const createPermintaan = async () => {
        if (selectedList.length === 0) {
            showToast('Pilih data terlebih dahulu', 'warning')
            return
        } else {
            setOpenProductDialog(true)
        }
    }

    const saveMulti = () => {
        // Cek apakah ada item dengan qty 0
        const hasZeroQty = selectedList.some((item: any) => {
            const qty = item.data?.qty_permintaan ?? item.qty_permintaan ?? 0
            return qty === 0
        })
        console.log('Selected Data:', selectedList);
        if (hasZeroQty) {
            setOpenProductDialog(false)
            Swal.fire({
                title: 'Peringatan',
                text: 'Tidak boleh ada item dengan qty 0. Silakan periksa kembali data Anda.',
                icon: 'warning'
            }).then(() => {
                setOpenProductDialog(true)
            })
            return
        }

        setOpenProductDialog(false)
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin membuat permintaan ini?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Buat'
        }).then(result => {
            if (result.isConfirmed) {
                showToast("Loading", "loading");
                const send = {
                    detail: JSON.stringify(selectedList),
                }

                let url = apiUrl.apiUrl + '/production/permintaan-preview/add-multi'

                axios
                    .post(url, send, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            showToast(response.data.message, "success");
                            setTimeout(() => {
                                location.reload();
                            }, 1000);
                        } else {
                            showToast(response.data.message, "error");
                        }
                    })
                    .catch(error => {
                        showToast(error.message, "error");
                    })
            }
        })
    }

    const otorisasiPermintaan = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin otorisasi data ini?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Buat'
        }).then(result => {
            if (result.isConfirmed) {
                showToast("Loading", "loading");
                const send = {
                    detail: JSON.stringify(selectedWoList),
                }

                let url = apiUrl.apiUrl + '/production/permintaan-preview/otorisasi-multi'

                axios
                    .post(url, send, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            showToast(response.data.message, "success");
                            getData(tabs)
                        } else {
                            showToast(response.data.message, "error");
                        }
                    })
                    .catch(error => {
                        showToast(error.message, "error");
                    })
            }
        })
    }

    const hapusRequest = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Buat'
        }).then(result => {
            if (result.isConfirmed) {
                showToast("Loading", "loading");
                const send = {
                    detail: JSON.stringify(selectedWoList),
                }

                let url = apiUrl.apiUrl + '/production/permintaan-preview/hapus-multi'

                axios
                    .post(url, send, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            showToast(response.data.message, "success");
                            getData(tabs)
                        } else {
                            showToast(response.data.message, "error");
                        }
                    })
                    .catch(error => {
                        showToast(error.message, "error");
                    })
            }
        })
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='Permintaan Preview 17' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/production/permintaan-preview/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='1' label='Daftar Permintaan Aktif' />
                            <Tab value='0' label='Permintaan Butuh Otorisasi' />
                            <Tab value='2' label='Daftar Barang MLFG' />
                        </TabList>
                        <TabPanel value='0'>
                            {selectedWoList.length > 0 ? (
                                <Box
                                    sx={{
                                        gap: 2,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        p: theme => theme.spacing(2, 0, 0, 0)
                                    }}
                                >
                                    {isOto === 0 ? ('') : (
                                        <>
                                            <Button
                                                variant='outlined'
                                                onClick={() => {
                                                    otorisasiPermintaan()
                                                }}
                                                startIcon={<Icon icon='mdi:check-circle-outline' />}
                                            >
                                                Otorisasi
                                            </Button>
                                            <Button
                                                variant='outlined'
                                                color='error'
                                                onClick={() => {
                                                    hapusRequest()
                                                }}
                                                startIcon={<Icon icon='mdi:trash' />}
                                            >
                                                Hapus Permintaan
                                            </Button>
                                        </>
                                    )}
                                </Box>
                            ) : null}
                            <MsiDatagridCheckbox array={listData} customRender={convertComponent} handleSelection={handleSelectionWo} hiddenColumns={['mmbarang_id', 'id']} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} customRender={convertComponentAktif} actions={actionData} hiddenColumns={['mmbarang_id']} />
                        </TabPanel>
                        <TabPanel value='2'>
                            {selectedList.length > 0 ? (
                                <Box
                                    sx={{
                                        gap: 2,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        p: theme => theme.spacing(2, 0, 0, 0)
                                    }}
                                >
                                    <Button
                                        variant='outlined'
                                        onClick={createPermintaan}
                                        startIcon={<Icon icon='mdi:text-box-check-outline' />}
                                    >
                                        Buat Permintaan
                                    </Button>
                                </Box>
                            ) : null}
                            <MsiDatagridCheckbox array={listData} customRender={convertComponent} handleSelection={handleSelection} hiddenColumns={['id']} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
            <Dialog
                open={openImageDialog}
                onClose={handleCloseImage}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    Preview Gambar
                    <IconButton
                        onClick={handleCloseImage}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <Icon icon="mdi:close" />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers sx={{ textAlign: 'center' }}>
                    {imagePreview && (
                        <img
                            src={imagePreview}
                            alt="Preview"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '70vh',
                                borderRadius: '10px'
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openProductDialog}
                onClose={() => setOpenProductDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List Permintaan
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={selectedList} customRender={convertComponent} hiddenColumns={["id"]} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button variant='contained' onClick={saveMulti}>Buat Permintaan</Button>
                    <Button onClick={() => setOpenProductDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
